import moment from 'moment';
import {
  FULFILLMENTS_VIEW_ID,
  FULFILLMENTS_RECENT_VIEW_ID,
  FULFILLMENTS_PENDING_VIEW_ID,
  FULFILLMENTS_IN_TRANSIT_VIEW_ID,
  FULFILLMENTS_DELIVERED_VIEW_ID,
  FULFILLMENTS_DELIVERY_EXCEPTION_VIEW_ID,
  FULFILLMENTS_CANCELLED_VIEW_ID,
  FULFILLMENTS_ADVANCED_SEARCH_VIEW_ID,
} from '../../components/shipping-grid/views/view-id-constants';

import { isIn } from '../../filters/operators/collection';
import { id as shipDateId } from '../../filters/options/ship-date';
import { id as isVoidedId } from '../../filters/options/is-voided';
import { id as isShippedId } from '../../filters/options/is-shipped';
import { id as submissionDate } from '../../filters/options/submission-date';
import { id as externalStatusId } from '../../filters/options/external-status';
import { FulfillmentStatusEnum } from '../../enums/external-fulfillment-status';

import { shipmentsAdvancedSearch } from '../../advanced-search/shipments/container';

const source = 'fulfillment-view';

const viewToFilterMap = {
  [FULFILLMENTS_VIEW_ID]: [],
  [FULFILLMENTS_RECENT_VIEW_ID]: [
    {
      id: shipDateId,
      source,
      value: {
        from: moment().add(-7, 'days').toISOString(),
      },
    },
  ],
  [FULFILLMENTS_PENDING_VIEW_ID]: [
    {
      id: isVoidedId,
      source,
      value: false,
    },
    {
      id: isShippedId,
      source,
      value: false,
    },
  ],
  [FULFILLMENTS_IN_TRANSIT_VIEW_ID]: [
    {
      id: isVoidedId,
      source,
      value: false,
    },
    {
      id: isShippedId,
      source,
      value: true,
    },
    {
      id: externalStatusId,
      operator: isIn,
      source,
      value: [
        FulfillmentStatusEnum.Received,
        FulfillmentStatusEnum.Planning,
        FulfillmentStatusEnum.Processing,
        FulfillmentStatusEnum.Shipped,
      ],
    },
  ],
  [FULFILLMENTS_DELIVERED_VIEW_ID]: [
    {
      id: isVoidedId,
      source,
      value: false,
    },
    {
      id: isShippedId,
      source,
      value: true,
    },
    {
      id: externalStatusId,
      operator: isIn,
      source,
      value: [FulfillmentStatusEnum.Complete, FulfillmentStatusEnum.CompletePartialled],
    },
    {
      id: shipDateId,
      source,
      value: {
        from: moment().add(-1, 'month').toISOString(),
      },
    },
  ],
  [FULFILLMENTS_DELIVERY_EXCEPTION_VIEW_ID]: [
    {
      id: isVoidedId,
      source,
      value: false,
    },
    {
      id: isShippedId,
      source,
      value: true,
    },
    {
      id: externalStatusId,
      operator: isIn,
      source,
      value: [
        FulfillmentStatusEnum.Rejected,
        FulfillmentStatusEnum.Unfulfillable,
        FulfillmentStatusEnum.Exception,
        FulfillmentStatusEnum.Invalid,
      ],
    },
  ],
  [FULFILLMENTS_CANCELLED_VIEW_ID]: [
    {
      id: isVoidedId,
      source,
      value: true,
    },
    {
      id: isShippedId,
      source,
      value: false,
    },
    {
      id: externalStatusId,
      operator: isIn,
      source,
      value: [FulfillmentStatusEnum.Cancelled],
    },
  ],
  [FULFILLMENTS_ADVANCED_SEARCH_VIEW_ID]: [
    {
      id: shipDateId,
      source: shipmentsAdvancedSearch,
      value: {
        from: moment().add(-90, 'days'),
      },
    },
    {
      id: submissionDate,
      source: shipmentsAdvancedSearch,
      value: {
        from: moment().add(-90, 'days'),
      },
    },
  ],
};

export const getFiltersForViewId = (viewId) => viewToFilterMap[viewId] ?? viewToFilterMap[FULFILLMENTS_VIEW_ID];
